import Vue from 'vue/dist/vue.esm'

function bodyContentsHeight() {
  var h = Math.max.apply(null, [
    document.body.clientHeight,
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.documentElement.clientHeight
  ])
  return h
}

function isSp(){
  var ua = navigator.userAgent
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    return true
  } else{
    return false
  }
}

var windowStatePlugin = {
  install: function(Vue) {
    // ウィンドウの状態
    var state = {
      scrollX: 0,
      scrollY: 0,
      height: 0,
      isSp: false,
    }

    var fps = 300 // 30fpsに制限
    var frameTime = 1000 / fps
    var isAnimated = false
    var lastTouchInfo = null
    //var element = document.getElementById('some-element');
    if (!process.server) {
      document.addEventListener('touchstart', function(ev) {
        lastTouchInfo = ev.changedTouches[0]
        isAnimated = true
        animation()
      })

      document.addEventListener('touchmove', function(ev) {
        lastTouchInfo = ev.changedTouches[0]
      })

      document.addEventListener('touchend', function() {
        isAnimated = false
        lastTouchInfo = null
      })

      document.addEventListener('touchcancel', function() {
        isAnimated = false
        lastTouchInfo = null
      })

      var isMobile = navigator.userAgent.match(
        // 精度上げるためにiOS省く
        /(Android|webOS|BlackBerry|IEMobile|Opera Mini)/i
      )

      if (!isMobile) {
        document.addEventListener('scroll', function() {
          isAnimated = true
          animation()
        })
      }

      function animation() {
        // isAnimatedフラグが立ってなかったら終了
        if (!isAnimated) {
          return
        }

        // 最後のタッチイベントからデータを取得
        //var x = lastTouchInfo.pageX;
        //var y = lastTouchInfo.pageY;
        onScroll()
        if (isMobile) {
          // 次のanimationを登録
          setTimeout(animation, frameTime)
        }
      }

      // スクロール数値を取得
      var onScroll = function() {
        state.scrollX = window.pageXOffset
        state.scrollY = window.pageYOffset
        state.height = bodyContentsHeight()
      }

      var deviseInfo = () => {
        state.isSp = isSp()
      }

      // 初期値を更新
      window.addEventListener('load', onScroll)
      window.addEventListener('load', deviseInfo)
    }
    // プロパティ $window を定義
    Vue.util.defineReactive(Vue.prototype, '$window', state)
  }
}

Vue.use(windowStatePlugin)
